import {NatomasMapFeatureType} from "@natomas-org/core";
import {setEligibilityMap} from "../../components/_shared/slices/CatalogSlice/CatalogSessionSlice";
import {useAddress} from "../../components/_shared/hooks/useAddress";
import {useDispatch} from "react-redux";
import {useEffect} from "react";
import {useGlobalConfiguration} from "../../components/_shared/hooks/useGlobalConfiguration";
import {useCurrentUser} from "../../components/_shared/hooks/useCurrentUser";
import {getEligibilityFeatures} from "./logic";

const featureTypes: [NatomasMapFeatureType, ...NatomasMapFeatureType[]] = [
  NatomasMapFeatureType.PRODUCT,
  NatomasMapFeatureType.FACTORY_LINE,
];

export const CatalogSessionEligibilityManager = (): null => {
  const {USE_FACTORY_ROUTING} = useGlobalConfiguration();
  const {catalogAddress: address} = useAddress();
  const {authInitialized, isSignedIn} = useCurrentUser();
  const dispatch = useDispatch();
  const {latitude, longitude} = address ?? {};

  useEffect(() => {
    if (!USE_FACTORY_ROUTING || !authInitialized) {
      return;
    }
    
    // Use location-based eligibility for both signed-in and signed-out users if coordinates are available
    if (latitude && longitude) {
      getEligibilityFeatures(featureTypes, latitude, longitude).then((r) => {
        if (r) {
          dispatch(setEligibilityMap(r));
        }
      });
    } else {
      // Only fall back to default eligibility when no coordinates are available
      // This shows the aduV2 factory (Woodland) as the default fallback
      const defaultEligibility = {factories: {aduV2: true}};
      dispatch(setEligibilityMap(defaultEligibility));
    }
  }, [USE_FACTORY_ROUTING, authInitialized, isSignedIn, dispatch, latitude, longitude, address]);

  return null;
};
